import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "component-side-bar" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("li", { class: "wx" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "er-code" })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("li", { class: "wb" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "er-code" })
], -1)


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

function backTop(): void {
  document.body.scrollTop = document.documentElement.scrollTop = 0;
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      _createVNode(_component_router_link, {
        to: { name: 'Search' },
        class: "search",
        custom: ""
      }, {
        default: _withCtx(({ navigate }) => [
          _createElementVNode("li", {
            class: "search",
            onClick: navigate
          }, null, 8, _hoisted_2)
        ]),
        _: 1
      }),
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("li", {
        class: "backTop",
        onClick: backTop
      })
    ])
  ]))
}
}

})